"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentDateTimestampSec = void 0;
exports.mountSlotModalRoleList = mountSlotModalRoleList;
exports.getAndUpdateRolesList = getAndUpdateRolesList;
exports.initSlotModalRoleListComponent = initSlotModalRoleListComponent;
exports.updateSlotModalRoleList = updateSlotModalRoleList;
exports.updateCurrentDate = updateCurrentDate;
const vue_1 = require("vue");
const SlotModalRolesList_vue_1 = __importDefault(require("./components/SlotModalRolesList.vue"));
const roleListComponent_1 = require("./enums/roleListComponent");
const role_1 = require("../webappApi/v2/parser/role");
const injectionKeys_1 = require("./types/injectionKeys");
const roleBranchMap = {};
const props = (0, vue_1.ref)({
    isLoading: false,
    rolesList: [],
    filterHiddenRoles: false,
    roleDates: {},
});
function mountSlotModalRoleList(roleListProps = { roleDates: {} }) {
    const app = (0, vue_1.createApp)(SlotModalRolesList_vue_1.default);
    props.value.roleDates = roleListProps.roleDates;
    app.provide(injectionKeys_1.SlotModalRoleListInjectionKey, props);
    app.provide("currentDate", {
        updateCurrentDate,
        currentDateTimestampSec: exports.currentDateTimestampSec,
    });
    app.mount(roleListComponent_1.SLOT_MODAL.ROLE_LIST);
}
async function getAndUpdateRolesList(branchId = 0, activeUserId = 0, filterHiddenRoles = false) {
    try {
        props.value.isLoading = true;
        props.value.filterHiddenRoles = filterHiddenRoles;
        const params = {
            branchId: branchId
        };
        if (activeUserId) {
            params.userId = activeUserId;
        }
        if (roleBranchMap[branchId] === undefined) {
            roleBranchMap[branchId] = [];
            const p = new URLSearchParams();
            if (params.branchId) {
                p.append('branchId', params.branchId.toString());
            }
            if (params.userId) {
                p.append('userId', params.userId.toString());
            }
            // Stamp Auth pages break if using webAppApi route. Use special dashboard route for all requests for now.
            const r = await fetch(`/dashboard/company/roles?${p.toString()}`, {
                method: "GET",
            });
            const response = await r.json();
            if (response.pagination.done && response.data) {
                response.data.forEach(res => {
                    if (res.isRoleSection) {
                        return;
                    }
                    const role = (0, role_1.parseRoleFromApi)(res);
                    roleBranchMap[branchId].push(role);
                });
            }
        }
        props.value.rolesList = roleBranchMap[branchId];
    }
    catch (err) {
        throw err;
    }
    finally {
        props.value.isLoading = false;
    }
}
async function initSlotModalRoleListComponent(activeBranchId, activeUserId, filterHiddenRoles = false, roleDates = {}) {
    await getAndUpdateRolesList(activeBranchId, activeUserId, filterHiddenRoles);
    mountSlotModalRoleList({ roleDates: roleDates });
}
async function updateSlotModalRoleList(activeBranchId, activeUserId, filterHiddenRoles = false) {
    await getAndUpdateRolesList(activeBranchId, activeUserId, filterHiddenRoles);
}
exports.currentDateTimestampSec = (0, vue_1.ref)(0);
function updateCurrentDate(dateTimestamp) {
    exports.currentDateTimestampSec.value = dateTimestamp;
}
